import { CongressesService } from "@/client";
import { useQuery } from "@tanstack/react-query";

const congressesQueryKey = ["congresses"];

function useCongresses() {
  return useQuery({
    queryKey: congressesQueryKey,
    queryFn: () => CongressesService.getCongresses(),
  });
}

export { congressesQueryKey, useCongresses };
